import Vue from 'vue'
import { VBTooltip } from 'bootstrap-vue'

Vue.directive('b-tooltip', VBTooltip)
